import React from 'react'
import { Footer, Body as ModalBody } from 'src/components/theme/Models/Modal'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FormGroup, FormText, Input, Label } from 'reactstrap'
import { faSend } from '@fortawesome/pro-regular-svg-icons'
import { useEeocContext } from 'src/pages/cat/candidates/Candidate/cards/EEOC/useEeoc'

interface BodyProps {
  id: string
}

const Body: React.FC<BodyProps> = (props) => {
  const { id } = props
  const [voidReason, setVoidReason] = React.useState<string>('')
  const { candidate, voidEeoc, modals: { void: voidModal } } = useEeocContext()
  const [error, setError] = React.useState<string | null>(null)

  const hasVoidReason = voidReason !== '' && voidReason !== null && voidReason !== undefined
  const disableSave = voidEeoc.isLoading || !hasVoidReason

  const handleSubmit = async (): Promise<void> => {
    if (!hasVoidReason) {
      setError('Please provide a reason to void the previous document.')
      return
    }
    const data = {
      candidate: id,
      voidReason
    }
    await voidEeoc.mutateAsync(data, {
      onSuccess: () => {
        voidModal.toggle()
      }
    })
  }

  return (
    <>
      <ModalBody
        error={{
          error: error ?? 'There was an issue sending the EEOC Paperwork.',
          show: error !== null
        }}
      >
        <p>Please provide a reason to void the previous EEOC documents for <b>{candidate?.lastFirstName}</b>.</p>
        <FormGroup className='mt-3'>
          <Label for='voidReason' className='fw-bold'>Void Reason:</Label>
          <Input
            type='text'
            name='voidReason'
            value={voidReason}
            onChange={(e) => setVoidReason(e.target.value)}
          />
          <FormText color='muted'>The void reason will be included in a notification to the candidate.</FormText>
        </FormGroup>
      </ModalBody>
      <Footer
        toggle={voidModal.toggle}
        onAction={handleSubmit}
        action={{
          text: 'Void',
          icon: voidEeoc.isLoading ? faSpinner : faSend,
          iconProps: { spin: voidEeoc.isLoading },
          color: 'primary',
          disabled: disableSave
        }}
      />
    </>
  )
}

export default Body
